export function formatPhoneInput(value) {
    if (!value) return '';

    // Удаляем все нецифровые символы
    const digits = value.replace(/\D/g, '');

    // Ограничиваем максимальную длину (11 цифр для российских номеров, 13 для беларусских)
    const trimmedDigits = digits.slice(0, 13);

    // Начинаем номер с 7 или 8 или +3 (российский и беларусские номер)
    let formattedNumber = '';
    if (trimmedDigits.length > 0) {

        // Заменяем ведущую 9 на +79
        if (trimmedDigits[0] === '9') {
            formattedNumber = '+79'
        } else if (trimmedDigits[0] === '3' || trimmedDigits[0] === '7') {
            formattedNumber = "+" + trimmedDigits[0]
        } else {
            formattedNumber = trimmedDigits[0]
        }

        if (trimmedDigits.length > 1) {
            formattedNumber += ` (${trimmedDigits.slice(1, 4)}`;
        }
        if (trimmedDigits.length > 4) {
            formattedNumber += `) ${trimmedDigits.slice(4, 7)}`;
        }
        if (trimmedDigits.length > 7) {
            formattedNumber += `-${trimmedDigits.slice(7, 9)}`;
        }
        if (trimmedDigits.length > 9) {
            formattedNumber += `-${trimmedDigits.slice(9, 11)}`;
        }
        if (trimmedDigits.length > 11) {
            formattedNumber += `-${trimmedDigits.slice(11, 13)}`;
        }
    }

    return formattedNumber;
}